import { StaticDependenciesService } from 'src/app/services/static-dependencies.service';

export function OnStart(config: { message?: string }) {
  const { message = '' } = config;
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      if (message) {
        StaticDependenciesService.zone.run(() => {
          StaticDependenciesService.toast.success(message);
        });
      }
      return originalMethod.apply(this, args);
    };
    return descriptor;
  };
}
